import React, { useCallback, useEffect, useState } from "react";

import { CircularIndeterminate } from "components";
import { useParams } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";

import { PersonalDataDashboard } from "./PersonalDataDashboard";

import { useRecoilValue } from "recoil";
import { userCredentials } from "recoilState/GlobalState";

import { merchantServicioUsuarioGet } from "services/services-mia";

import s from "styles/pages/Pages.module.scss"

function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

export default function UserDetailsDashboard({
    usuarioId = null,
    merchantServicioUsuarioId = null,
}) {
    const [user, setUser] = useState();
    // const [didDocument, setDidDocument] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    const credentials = useRecoilValue(userCredentials);

    const params = useParams()

    const getUser = useCallback(async (id, merchantServicioUsuarioIdParam) => {
        setIsLoading(true);

        let userData = null;

        if (merchantServicioUsuarioIdParam) {
            const result = await merchantServicioUsuarioGet(
                { merchantServicioUsuarioId: merchantServicioUsuarioIdParam },
                credentials
            );
            userData = result?.[0] ?? null;
        }

        setUser(userData);
        /*
        if (userData?.usuarioDID) {
            const didBody = {
                service: "DIDResolveDo",
                params: {
                    did: userData.usuarioDID,
                },
            };

            try {
                const didResult = await RequestServiceGet(
                    didBody,
                    credentials,
                    setSnackbarInfo
                );

                if (didResult && didResult[0]?.didDocument) {
                    setDidDocument(JSON.stringify(didResult[0].didDocument, null, 2));
                }
            } catch (error) {
                console.error("Error fetching DID document:", error);
            }
        }
        */

        setIsLoading(false);
    }, [credentials])

    useEffect(() => {
        getUser(usuarioId ?? params?.UsuarioId, merchantServicioUsuarioId);
    }, [getUser, usuarioId, merchantServicioUsuarioId, params?.UsuarioId]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    if (isLoading || !user) {
        return (
            <main className={s.main}>
                <CircularIndeterminate />
            </main>
        );
    }

    return (
        <main className={s.main}>
            <div>
                <Box>
                    <Tabs 
                        value={tabValue} 
                        onChange={handleTabChange}
                        sx={{
                            width: '100%',
                            '& .MuiTabs-indicator': {
                                display: 'none'
                            }
                        }}
                    >
                        <Tab 
                            label="Onboard"
                            sx={{
                                flex: 1,
                                backgroundColor: 'transparent',
                                borderBottom: tabValue === 0 ? '3px solid #FF6D00' : '3px solid transparent',
                                color: '#000',
                                '&.Mui-selected': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                        />
                        {/* <Tab 
                            label="SSI"
                            sx={{
                                flex: 1,
                                backgroundColor: 'transparent',
                                borderBottom: tabValue === 1 ? '3px solid #FF6D00' : '3px solid transparent',
                                color: '#000',
                                '&.Mui-selected': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                        />
                        <Tab 
                            label="Eventos"
                            sx={{
                                flex: 1,
                                backgroundColor: 'transparent',
                                borderBottom: tabValue === 2 ? '3px solid #FF6D00' : '3px solid transparent',
                                color: '#000',
                                '&.Mui-selected': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                        /> */}
                    </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                    <PersonalDataDashboard user={user} />
                </TabPanel>
                {/* <TabPanel value={tabValue} index={1}>
                    <SSITab user={user} didDocument={didDocument} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <EventosTab user={user} />
                </TabPanel>
                */}
            </div>
        </main>
    );
}